import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  headerText: {
    fontWeight: '600',
  },
  container: {
    paddingHorizontal: indent,
    backgroundColor: cloudLightest,
    flex: 1,
  },
});
